(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jmo-halloween-atmosphere"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('JmoHauntedWorld');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const html = document.documentElement;
    const expiry = Number(root.dataset.hauntExpires);
    const button = root.querySelector('[data-haunt-toggle]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer;
    let paused = reduce.matches;
    try { paused = paused || sessionStorage.getItem('jmo-halloween-paused') === 'true'; } catch {}
    const updateMotion = () => {
      html.classList.toggle('jmo-haunt-paused', paused || reduce.matches);
      button.setAttribute('aria-pressed', String(paused || reduce.matches));
      button.querySelector('span').textContent = paused || reduce.matches ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.hidden = reduce.matches;
    };
    const checkSeason = () => {
      window.clearTimeout(timer);
      if (!Number.isFinite(expiry) || Date.now() >= expiry) {
        root.hidden = true;
        html.classList.remove('jmo-haunted', 'jmo-haunt-paused', 'jmo-haunt-sleep');
        document.querySelectorAll('[data-jmo-halloween]').forEach((element) => {
          element.hidden = true;
          const wrapper = element.closest('.shopify-section');
          if (wrapper) wrapper.hidden = true;
        });
        return;
      }
      root.hidden = false;
      html.classList.add('jmo-haunted');
      timer = window.setTimeout(checkSeason, Math.min(expiry - Date.now(), 2147483647));
      updateMotion();
    };
    button.addEventListener('click', () => {
      paused = !paused;
      try { sessionStorage.setItem('jmo-halloween-paused', String(paused)); } catch {}
      updateMotion();
    });
    reduce.addEventListener('change', updateMotion);
    window.addEventListener('pageshow', checkSeason);
    document.addEventListener('visibilitychange', () => {
      html.classList.toggle('jmo-haunt-sleep', document.visibilityState === 'hidden');
      if (document.visibilityState === 'visible') checkSeason();
    });
    document.addEventListener('shopify:section:load', checkSeason);
    checkSeason();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jmo-order-discount-note"] && !Shopify.designMode) return;
  try {
    (() => {
    let expiryTimer;
    const updateDiscountNotes = () => {
      window.clearTimeout(expiryTimer);
      let nextExpiry = Infinity;
      const now = Date.now();
      document.querySelectorAll('[data-jmo-discount-until]').forEach((note) => {
        const expiresAt = Number(note.dataset.jmoDiscountUntil);
        if (!Number.isFinite(expiresAt) || expiresAt <= now) {
          note.hidden = true;
        } else {
          nextExpiry = Math.min(nextExpiry, expiresAt - now);
        }
      });
      if (now >= 1793505600000) {
        document.querySelectorAll('[data-jmo-price-group]').forEach((group) => {
          const price = group.querySelector('[data-jmo-price]');
          if (price) price.textContent = group.dataset.jmoCatalogPriceText;
          group.querySelectorAll('[data-jmo-before-promotion], [data-jmo-sale-badge]').forEach((element) => { element.hidden = true; });
          const compare = group.querySelector('[data-jmo-compare]');
          if (compare) {
            compare.textContent = group.dataset.jmoCompareText || '';
            compare.hidden = Number(group.dataset.jmoCatalogPrice) <= 0 || Number(group.dataset.jmoComparePrice) <= Number(group.dataset.jmoCatalogPrice);
          }
        });
        document.querySelectorAll('[data-jmo-native-option-label]').forEach((option) => { option.textContent = option.dataset.jmoNativeOptionLabel; });
        document.dispatchEvent(new Event('jmo:promotion-expired'));
      }
      if (Number.isFinite(nextExpiry)) expiryTimer = window.setTimeout(updateDiscountNotes, Math.min(nextExpiry + 20, 2147483647));
    };
    updateDiscountNotes();
    window.addEventListener('pageshow', updateDiscountNotes);
    document.addEventListener('visibilitychange', updateDiscountNotes);
    document.addEventListener('shopify:section:load', updateDiscountNotes);
  })();
  } catch(e) { console.error(e); }
})();

})();
